import NewPatientsNotificationsContainer from './new-patients-notifications-container';

export default NewPatientsNotificationsContainer;
